import clsx from 'clsx';
import { useT } from '../../i18n';
import { STAGE_ORDER, type Stage } from '../../types/api';
import styles from './StageProgress.module.css';

/**
 * Issue #51 — quiet progress dots shown instead of the day counter on
 * early-stage deals (before «ТКП»). One dot per pipeline stage: completed
 * steps are filled, the current one is accented. Not a shared component —
 * lives next to DealCard and is reused by the list view.
 */
export function StageProgress({ stage }: { stage: Stage }) {
  const { t } = useT();
  const current = STAGE_ORDER.indexOf(stage);
  return (
    <span
      className={styles.dots}
      role="img"
      aria-label={t('inquiries.stageProgress', { current: current + 1, total: STAGE_ORDER.length })}
    >
      {STAGE_ORDER.map((s, i) => (
        <span
          key={s}
          className={clsx(
            styles.dot,
            i < current && styles.done,
            i === current && styles.current,
          )}
        />
      ))}
    </span>
  );
}
